module.exports = __webpack_public_path__ + "static/media/A14.f2b14e93.jpg";